// generated/models/agentProposalToolName.ts
var AgentProposalToolName = {
  propose_line_item_archive: "propose_line_item_archive",
  propose_line_item_formula_update: "propose_line_item_formula_update",
  propose_line_item_permutation_update: "propose_line_item_permutation_update",
  propose_room_create: "propose_room_create",
  propose_room_rename: "propose_room_rename",
  propose_room_archive: "propose_room_archive",
  propose_line_item_create: "propose_line_item_create"
};

export {
  AgentProposalToolName
};
//# sourceMappingURL=chunk-FKMHKI2U.mjs.map